import React from "react";
import { cn } from "../../lib/cn";

export const Input = React.forwardRef(
  ({ label, error, id, className, ...props }, ref) => {
    const inputId = id || (label ? `input-${label.toLowerCase().replace(/\s+/g, "-")}` : undefined);
    const errorId = error && inputId ? `${inputId}-error` : undefined;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-neutral-700 mb-1.5"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            "w-full rounded-xl border border-neutral-200 bg-white px-4 py-3 text-sm",
            "focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300",
            "disabled:opacity-60 disabled:cursor-not-allowed",
            error && "border-red-300 focus:ring-red-200 focus:border-red-400",
            className
          )}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={errorId}
          {...props}
        />
        {error && (
          <p
            id={errorId}
            className="mt-1.5 text-sm text-red-600"
            role="alert"
          >
            {error}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
